import { useTranslation } from 'react-i18next';
import {
  DownOutlined,
  PlusOutlined,
  SettingOutlined,
  FilterOutlined,
  DeleteOutlined,
  SearchOutlined,
  UpOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Row,
  Col,
  Button,
  Typography,
  Dropdown,
  Form,
  DatePicker,
  FormInstance,
} from "antd";
import React, { ChangeEvent, FunctionComponent, useState } from "react";
import PageHeader from "../../../../../components/page-header/PageHeader";
import FormItemInput from "../../../../../components/form-input/FormInput";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";
import { FilterData } from "../../../../../types/course-construction";

type PageHeaderType = {
  handleOpen: () => void;
  title?: string | null;
  searchValue: string;
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void;
  filterData: FilterData;
  setFilterData: (dateString: string[], planCreationDate: string) => void;
  handleSubmitSearch: () => void;
  clearFilter: () => void;
  form: FormInstance;
};
const FilterSurvey: FunctionComponent<PageHeaderType> = ({
  handleOpen,
  title,
  searchValue,
  handleChangeInput,
  filterData,
  setFilterData,
  handleSubmitSearch,
  clearFilter,
  form,
}) => {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;
  const [showFilter, setShowFilter] = useState(false);

  const [dataOptions, setDataOptions] = useState({
    dataStatus: [
      {
        id: 1,
        name: t("Tự triển khai", "Tự triển khai"),
      },
      {
        id: 2,
        name: t("Hợp tác xây dựng", "Hợp tác xây dựng"),
      },
      {
        id: 3,
        name: t("Dùng chung", "Dùng chung"),
      },
    ],
    dataTypes: [
      {
        id: 5,
        name: t("Đã xuất bản", "Đã xuất bản"),
      },
      {
        id: 6,
        name: t("Kết thúc", "Kết thúc"),
      },
    ],
  });

  const openFilter = () => {
    setShowFilter(!showFilter);
  };

  return (
    <Layout className="page-header-group">
      <div
        className={`page-header-group--layout ${
          showFilter ? "open-filter" : ""
        }`}
      >
        <div className="table-header--wrapper">
          <div className="table-header--left">
            <PageHeader title={title} />
          </div>
          <div className="heading-extra">
            <Row gutter={[{ md: 8, xl: 8, xs: 8 }, 8]}>
              <Col
                md={{ span: 2 }}
                lg={{ span: 1 }}
                xl={{ span: 1 }}
                xs={{ span: 1 }}
              >
                {/* <div className="heading-filter">
                  <Button className="filter-button" onClick={openFilter}>
                    <Typography.Text>{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
                    <DownOutlined />
                  </Button>
                </div> */}
              </Col>
              <Col
                md={{ span: 7 }}
                lg={{ span: 7 }}
                xl={{ span: 7 }}
                xs={{ span: 6 }}
              >
                <div className="heading-filter">
                  <Button className="filter-button" onClick={openFilter}>
                    <Typography.Text>{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
                    {showFilter ? <UpOutlined /> : <DownOutlined />}
                  </Button>
                </div>
              </Col>
              <Col
                md={{ span: 14 }}
                lg={{ span: 15 }}
                xl={{ span: 15 }}
                xs={{ span: 17 }}
              >
                <div className="heading-search">
                  <FormItemInput
                    placeholder={t("Nhập từ khoá cần tìm", "Nhập từ khoá cần tìm")}
                    value={searchValue}
                    onChange={handleChangeInput}
                    afterPrefixIcon={
                      <SearchOutlined onClick={handleSubmitSearch} />
                    }
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
          <Form form={form} name="filterForm">
            <Row gutter={[{ md: 8, xl: 8, xs: 8 }, 8]}>
              <Col
                xl={{ span: 4 }}
                md={{ span: 5 }}
                sm={{ span: 5 }}
                xs={{ span: 24 }}
              >
                <Form.Item name="createDate" className="">
                  <RangePicker
                    format="DD-MM-YYYY"
                    placeholder={[t("Ngày xuất bản", "Ngày xuất bản"), t("Ngày xuất bản", "Ngày xuất bản")]}
                    value={filterData.createDate}
                    onChange={(_value, dateString: any) => {
                      const convertedDates = dateString.map((date: String) => {
                        const [day, month, year] = date.split("-");
                        return `${year}-${month}-${day}`;
                      });
                      setFilterData(convertedDates, "createDate");
                    }}
                  />
                </Form.Item>
              </Col>
              <Col
                xl={{ span: 4 }}
                md={{ span: 5 }}
                sm={{ span: 5 }}
                xs={{ span: 24 }}
              >
                <Form.Item name="publicDate" className="">
                  <RangePicker
                    placeholder={[t("Ngày bắt đầu", "Ngày bắt đầu"), t("Ngày kết thúc", "Ngày kết thúc")]}
                    format="DD-MM-YYYY"
                    value={filterData.publicDate}
                    onChange={(_value, dateString: any) => {
                      const convertedDates = dateString.map((date: String) => {
                        const [day, month, year] = date.split("-");
                        return `${year}-${month}-${day}`;
                      });
                      setFilterData(convertedDates, "publicDate");
                    }}
                  />
                  {/* <DatePicker placeholder={t('Ngày xuất bản', 'Ngày xuất bản')}/> */}
                </Form.Item>
              </Col>
              <Col
                xl={{ span: 4 }}
                md={{ span: 5 }}
                sm={{ span: 5 }}
                xs={{ span: 24 }}
              >
                <Form.Item name="status">
                  <FormItemDropdown
                    placeholder={t("Trạng thái", "Trạng thái")}
                    modeDropdown="multiple"
                    value={filterData.status}
                    options={dataOptions.dataTypes}
                    onChange={(option) => {
                      setFilterData(option, "status");
                    }}
                  />
                </Form.Item>
              </Col>
              <Col
                xl={{ span: 4 }}
                md={{ span: 5 }}
                sm={{ span: 5 }}
                xs={{ span: 24 }}
              >
                <Form.Item name="type">
                  <FormItemDropdown
                    placeholder={t("Loại khoá học", "Loại khoá học")}
                    modeDropdown="multiple"
                    value={filterData.courseType}
                    options={dataOptions.dataStatus}
                    onChange={(option) => {
                      setFilterData(option, "courseType");
                    }}
                  />
                </Form.Item>
              </Col>
              <Col
                xl={{ span: 6 }}
                md={{ span: 9 }}
                sm={{ span: 9 }}
                xs={{ span: 24 }}
              >
                <div className="group-btn--filter">
                  <Button
                    className="btn btn-primary filter-btn"
                    // htmlType="submit"
                    onClick={handleSubmitSearch}
                    // onClick={() => form.submit()}
                  >
                    <FilterOutlined />
                    <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
                  </Button>
                  <Button
                    className="btn btn-outlined clear-filter-btn"
                    onClick={clearFilter}
                  >
                    <DeleteOutlined />
                    <Typography.Text>{t("Xóa tất cả", "Xóa tất cả")}</Typography.Text>
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </Layout>
  );
};

export default FilterSurvey;
